import { Injectable } from '@angular/core';

export interface NavGroupItem {
    label: string;
    link?: string[];
    queryParams?: Record<string, string>;
    action?: 'jobs';      // Jobs uses handleJobsClick() (clears saved job prefs) instead of a plain link
    highlight?: boolean;  // orange, for the summit CTA
    authOnly?: boolean;   // messages need a signed-in user
}
export interface NavGroup { label: string; items: NavGroupItem[]; }

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    // navData = [
    //     { routeLink: 'hustles', icon: 'fa-user-helmet-safety', label: 'Hustles', visible: true },
    //     // { routeLink: 'rewards', icon: 'fa-ribbon', label: 'Rewards', visible: true },
    //     { routeLink: 'referral', icon: 'fa-user-plus', label: 'Referrals', visible: true },
    //     { routeLink: 'sponsors', icon: 'fa-hand-holding-dollar', label: 'Sponsors', visible: true },
    //     // { routeLink: 'tutorial', icon: 'fa-screen-users', label: 'Tutorial', visible: true },
    //     // { routeLink: 'resources', icon: 'fa-treasure-chest', label: 'Resources', visible: true },
    //     { routeLink: 'mission', icon: 'fa-bullseye-arrow', label: 'Mission', visible: true },
    //     // { routeLink: 'jobs', icon: 'fa-briefcase', label: 'Jobs', visible: true },
    //     { routeLink: 'contact', icon: 'fa-envelope-open-text', label: 'Contact Us', visible: true },
    //     { routeLink: 'live', icon: 'fa-signal-stream', label: 'Live Video', visible: true },
    // ];

    // Header groups from the Sep 1 homepage mockup. Every link that was in
    // the old flat bar or More menu is here; dropdown targets point at pages
    // that exist today (Rewards stays hidden, its code is switched off).
    navGroups: NavGroup[] = [
        { label: 'Jobs', items: [
            { label: 'Browse Jobs', action: 'jobs' },
            { label: 'Career Resources', link: ['/jobs'] },
            { label: 'For Employers', link: ['/jobs'], queryParams: { view: 'all' } },
            { label: 'Side Hustles', link: ['/hustles'] },
        ] },
        { label: 'Resources', items: [
            { label: 'Articles & Guides', link: ['/content', 'article'] },
            { label: 'Templates', link: ['/content', 'written-program'] },
            { label: 'Checklists', link: ['/content', 'written-program'] },
            { label: 'Tools', link: ['/content'] },
            { label: 'Podcasts', link: ['/podcasts'] },
            { label: 'Quizzes', link: ['/quizzes'] },
            { label: 'Live Video', link: ['/live'] },
        ] },
        { label: 'Education & Events', items: [
            { label: "Attend People's Summit", link: ['/peoples_summit'], highlight: true },
            { label: 'Upcoming Events', link: ['/content', 'event-webinar'] },
            { label: 'Webinars & Recordings', link: ['/content', 'videos'] },
            { label: 'Continuing Education', link: ['/content'] },
        ] },
        { label: 'Community', items: [
            { label: 'Discussions', link: ['/community'] },
            { label: 'Ask a Question', link: ['/community'] },
            { label: 'Member Directory', link: ['/search'] },
            { label: 'Referrals', link: ['/referral'] },
            { label: 'Messages', link: ['/messages'], authOnly: true },
        ] },
        { label: 'Find Solutions', items: [
            { label: 'Preferred Partners', link: ['/partners'] },
            { label: 'By Category', link: ['/partners'] },
            { label: 'Become a Partner', link: ['/partners'] },
            { label: 'Become a Sponsor', link: ['/sponsors'] },
        ] },
        { label: 'About', items: [
            { label: 'About Us', link: ['/mission'] },
            { label: 'Contact Us', link: ['/contact'] },
            { label: 'Sponsor', link: ['/sponsors'] },
            { label: 'Advertise', link: ['/sponsors'] },
        ] },
    ];

        navData = [
        { routeLink: 'hustles', icon: 'heroUsers', label: 'Hustles', visible: true },
        //{ routeLink: 'rewards', icon: 'heroTrophy', label: 'Rewards', visible: true },
        // { routeLink: 'referral', icon: 'heroUserPlus', label: 'Referrals', visible: true },
        { routeLink: 'partners', icon: 'heroHandRaised', label: 'Partners', visible: true },
        { routeLink: 'sponsors', icon: 'heroCurrencyDollar', label: 'Sponsors', visible: true },
       // { routeLink: 'tutorial', icon: 'heroAcademicCap', label: 'Tutorial', visible: true },
       // { routeLink: 'resources', icon: 'heroArchiveBox', label: 'Resources', visible: true },
        { routeLink: 'mission', icon: 'heroRocketLaunch', label: 'Mission', visible: true },
       // { routeLink: 'jobs', icon: 'heroBriefcase', label: 'Jobs', visible: true },
       { routeLink: 'live', icon: 'heroVideoCamera', label: 'Live Video', visible: true },
       { routeLink: 'contact', icon: 'heroEnvelopeOpen', label: 'Contact Us', visible: true },
        ];
}
